import React, { useState, useEffect } from 'react';
import eventAPI from '../services/eventAPI';
import './CalendarFeedSubscription.css';

function CalendarFeedSubscription() {
  const [feedData, setFeedData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [copied, setCopied] = useState(false);
  const [regenerating, setRegenerating] = useState(false);

  useEffect(() => {
    loadFeedToken();
  }, []);

  const loadFeedToken = async () => {
    try {
      setLoading(true);
      const data = await eventAPI.getCalendarFeedToken();
      setFeedData(data);
      setError(null);
    } catch (err) {
      console.error('Failed to load calendar feed token:', err);
      setError('Fehler beim Laden des Kalender-Feeds');
    } finally {
      setLoading(false);
    }
  };

  const handleRegenerate = async () => {
    if (!window.confirm('Möchtest du einen neuen Link generieren? Der alte Link funktioniert dann nicht mehr.')) {
      return;
    }

    try {
      setRegenerating(true);
      const data = await eventAPI.generateCalendarFeedToken();
      setFeedData(data);
      setError(null);
      setCopied(false);
    } catch (err) {
      console.error('Failed to regenerate token:', err);
      setError('Fehler beim Generieren eines neuen Links');
    } finally {
      setRegenerating(false);
    }
  };

  const handleCopyLink = () => {
    const url = eventAPI.getCalendarFeedUrl(feedData.token);
    navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  const handleOpenInCalendar = () => {
    const webcalUrl = eventAPI.getWebcalUrl(feedData.token);
    window.location.href = webcalUrl;
  };

  if (loading) {
    return (
      <div className="calendar-feed-subscription">
        <div className="feed-loading">Lädt...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="calendar-feed-subscription">
        <div className="feed-error">{error}</div>
      </div>
    );
  }

  const feedUrl = feedData ? eventAPI.getCalendarFeedUrl(feedData.token) : '';

  return (
    <div className="calendar-feed-subscription">
      <div className="feed-header">
        <div className="feed-icon">[#]</div>
        <div className="feed-title-section">
          <h3 className="feed-title">KALENDER ABONNIEREN</h3>
          <p className="feed-description">
            Abonniere deinen persönlichen Kalender-Feed — alle deine Events werden automatisch synchronisiert, inklusive aktuellem Status und Teilnehmern.
          </p>
        </div>
      </div>

      <div className="feed-url-section">
        <label className="feed-label">KALENDER-LINK:</label>
        <div className="feed-url-display">
          <input
            type="text"
            className="feed-url-input"
            value={feedUrl}
            readOnly
            onClick={(e) => e.target.select()}
          />
        </div>
      </div>

      <div className="feed-actions">
        <button
          className="retro-button retro-button-primary"
          onClick={handleOpenInCalendar}
        >
          IN KALENDER ÖFFNEN
        </button>
        <button
          className="retro-button"
          onClick={handleCopyLink}
        >
          {copied ? '✓ KOPIERT' : 'LINK KOPIEREN'}
        </button>
        <button
          className="retro-button feed-regenerate-btn"
          onClick={handleRegenerate}
          disabled={regenerating}
        >
          {regenerating ? 'GENERIERE...' : 'NEUEN LINK GENERIEREN'}
        </button>
      </div>

      <div className="feed-instructions">
        <h4 className="instructions-title">[?] ANLEITUNG</h4>
        <div className="instructions-content">
          <div className="instruction-step">
            <strong>Option 1:</strong> Klicke auf "IN KALENDER ÖFFNEN" um den Feed direkt zu deiner Kalender-App hinzuzufügen.
          </div>
          <div className="instruction-step">
            <strong>Option 2:</strong> Kopiere den Link und füge ihn manuell in deiner Kalender-App hinzu:
            <ul>
              <li><strong>Apple Kalender:</strong> Datei → Neues Kalender-Abonnement → Link einfügen</li>
              <li><strong>Google Kalender:</strong> Andere Kalender → Über URL hinzufügen → Link einfügen</li>
              <li><strong>Outlook:</strong> Kalender hinzufügen → Aus dem Internet → Link einfügen</li>
            </ul>
          </div>
          <div className="instruction-note">
            <strong>Hinweis:</strong> Alle Events werden synchronisiert — Kalender-Termine, Planungs-Events und Abstimmungen. Der Status (bestätigt, in Planung, etc.) und die Teilnehmer stehen direkt im Termin.
          </div>
        </div>
      </div>
    </div>
  );
}

export default CalendarFeedSubscription;
